import {NgModule} from '@angular/core';
import {ConfigPage} from "./page/overview/config/config.page";
import {
    OlOutletDashboardOverviewComponent
} from "./page/ol-outlet-dashboard-overview/ol-outlet-dashboard-overview.component";
import {
    OlOutletObjectComponent
} from "./component/object-components/ol-outlet-object-component/ol-outlet-object.component";
import {
    OlOutletBaseComponent
} from "./component/object-components/ol-outlet-object-component/view/ol-outlet-base.component";
import {
    OlOutletSideComponent
} from "./component/object-components/ol-outlet-object-component/view/ol-outlet-side-component/ol-outlet-side-component";
import {
    OlOutletFullComponent
} from "./component/object-components/ol-outlet-object-component/view/ol-outlet-full-component/ol-outlet-full-component";
import {
    OlOutletComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-component/ol-outlet.component";
import {
    OlOutletBlogPostComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-blog-post-component/ol-outlet-blog-post.component";
import {
    OlOutletBlogGhostWriterComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-blog-ghost-writer-component/ol-outlet-blog-ghost-writer.component";
import {
    CreateBlogPostComponent
} from "./component/protected-components/create-blog-post-component/create-blog-post.component";
import {
    BlogPostPreviewComponent
} from "./component/protected-components/create-blog-post-component/blog-post-preview-component/blog-post-preview.component";
import {
    OlOutletActiveThemeComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-active-theme-component/ol-outlet-active-theme.component";
import {
    OutletInfoComponent
} from "./page/ol-outlet-dashboard-overview/components/outlet-info-component/outlet-info.component";
import {OL_ENTITY_PROVIDER} from "./ol.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {OL_TEST_PROVIDERS} from "./test/ol-test-definition";
import {
    OlOutletContentMaintainComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-content-maintain-component/ol-outlet-content-maintain.component";
import {
    OlOutletContentTypeObjectComponent
} from "./component/object-components/ol-outlet-content-type-object-component/ol-outlet-content-type-object.component";
import {
    OlOutletContentTypeFullComponent
} from "./component/object-components/ol-outlet-content-type-object-component/view/ol-outlet-content-type-component-full/ol-outlet-content-type-full.component";
import {
    OlOutletContentTypeSideComponent
} from "./component/object-components/ol-outlet-content-type-object-component/view/ol-outlet-content-type-component-side/ol-outlet-content-type-side.component";
import {
    OlOutletContentTypeBaseComponent
} from "./component/object-components/ol-outlet-content-type-object-component/view/ol-outlet-content-type-base.component";
import {
    OlOutletContentPreviewComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-content-maintain-component/ol-outlet-content-preview-component/ol-outlet-content-preview.component";
import {
    OlOutletPromotionComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-promotion/ol-outlet-promotion.component";
import {
    OlOutletCreateContentComponent
} from "./component/object-components/ol-outlet-object-component/shared/components/ol-outlet-create-content-component/ol-outlet-create-content.component";
import {OlOutletObjectPage} from "./page/object/ol-outlet-object-page/ol-outlet-object.page";

@NgModule({
    declarations: [
        ConfigPage,
        OlOutletDashboardOverviewComponent,
        OlOutletObjectPage,
        OlOutletObjectComponent,
        OlOutletBaseComponent,
        OlOutletSideComponent,
        OlOutletFullComponent,
        OlOutletComponent,
        OlOutletBlogPostComponent,
        OlOutletBlogGhostWriterComponent,
        CreateBlogPostComponent,
        BlogPostPreviewComponent,
        OlOutletActiveThemeComponent,
        OutletInfoComponent,
        OlOutletContentMaintainComponent,
        OlOutletContentTypeObjectComponent,
        OlOutletContentTypeFullComponent,
        OlOutletContentTypeSideComponent,
        OlOutletContentTypeBaseComponent,
        OlOutletContentPreviewComponent,
        OlOutletPromotionComponent,
        OlOutletCreateContentComponent,
    ],
    exports: [
        ConfigPage,
    ],
    imports: [
        CoreModule,
        //BmModule,
        UiModule,
    ],
    providers: [OL_ENTITY_PROVIDER, OL_TEST_PROVIDERS]
})
export class OlModule { }
